var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 10.5001H26.0407H24.9893C24.0841 10.5001 23.3502 11.2339 23.3502 12.1392V17.8898H30L29.0261 24.2206H23.3502V35.8337H16.0376V24.2206H10V17.8898H15.9596L16.0376 11.8806L16.0265 10.7896C15.9899 7.16881 18.8954 4.20394 22.5162 4.16733C22.5382 4.1671 22.5603 4.16699 22.5824 4.16699H30V10.5001Z",
    fill: "#2F88FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIcon);
export default __webpack_public_path__ + "static/media/fb_icon.7c62d4e5ac351258e328d5a3f12e9bb2.svg";
export { ForwardRef as ReactComponent };